import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { IProductDataV2, Product } from '@df/catalog/product/product';
import { DfModal } from '@df/ui/modal/df-modal.decorator';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { MODAL_DATA } from '@df/ui/modal/modal.service';
import { UiComponent } from '@df/ui/ui.component';
import { NICmsContentComponent } from '@icms/core/content';
import { ModalLayoutComponent, NModalLayout } from '../../../common/modal/layout/modal-layout.component';
import { ProductTierPriceComponent } from '../tier-price/product-tier-price.component';
import { TranslationModule } from '@df/ui/translation/translation.module';

export namespace NProductTierPriceModal {
    export const MODAL_ID = 'product-tier-price-modal';

    export interface IModalData {
        product: Product<IProductDataV2>;
        onSelect: (qty: number) => void;
    }
}

@DfModal({
    id: NProductTierPriceModal.MODAL_ID,
    name: 'Product Tier Price Modal',
    position: sizeName => (sizeName === 'X' || sizeName === 'L' ? 'right' : 'bottom'),
    config: size => ({
        ...(['S', 'M'].includes(size) ? NModalLayout.Bottom.modalConfig()(size) : NModalLayout.Right.modalConfig()(size)),
        modalClass: 'p-a-0'
    }),
    reopenPolicy: NDfModal.ReopenPolicy.last,
    sizeRestriction: sizeId => (['S', 'M'].includes(sizeId) ? ['S', 'M'] : ['X', 'L']),
    prerenderAllowed: false
})
@Component({
    selector: 'product-tier-price-modal',
    templateUrl: './product-tier-price-modal.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ProductTierPriceComponent, TranslationModule, ModalLayoutComponent]
})
export class ProductTierPriceModalComponent extends UiComponent implements NICmsContentComponent.IComponent, OnInit {
    protected modalData = inject(MODAL_DATA) as NProductTierPriceModal.IModalData;

    protected product!: Product<IProductDataV2>;
    private modalRef = inject(ModalRef);

    override ngOnInit(): void {
        this.product = this.modalData.product;
        super.ngOnInit();
    }

    protected handleQtyChange(qty: number): void {
        this.modalData.onSelect(qty);
        this.modalRef.close();
    }
}
